
import { useEffect, useState } from "react"
import "./index.scss"

function Homepage() {

  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;
    const data = new FormData(form);

    const response = await fetch('https://formsubmit.co/support@birdiesstore.com', {
      method: 'POST',
      body: data,
    });

    if (response.ok) {
      setStatus("Thanks for your message!");
      form.reset();
    } else {
      setStatus("Oops! Something went wrong.");
    }
  };


  useEffect(() => {
    // Mobile menu toggle
    const mobileMenuBtn = document.querySelector(".y-mobile-menu-btn")
    if (mobileMenuBtn) {
      mobileMenuBtn.addEventListener("click", () => {
        const navLinks = document.querySelector(".y-nav-links")
        navLinks.classList.toggle("y-active")
      })
    }

    // Cleanup event listener on unmount
    return () => {
      const mobileMenuBtn = document.querySelector(".y-mobile-menu-btn")
      if (mobileMenuBtn) {
        mobileMenuBtn.removeEventListener("click", () => {
          const navLinks = document.querySelector(".y-nav-links")
          navLinks.classList.toggle("y-active")
        })
      }
    }
  }, [])

  return (
    <>
      {/* Header */}
      <header>
        <div className="y-container">
          <nav className="y-navbar">
            <img
              src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Birdies%20Logo%20Plain%20%281%29%20%281%29.jpg-HOSyoEEoJ18kWlpTqlUZpdMIUD5Hzx.jpeg"
              alt="Birdies Logo"
              className="y-logo"
            />
            <ul className="y-nav-links">
              <li>
                <a href="#about">About</a>
              </li>
              <li>
                <a href="#services">Services</a>
              </li>
              <li>
                <a href="#food">Food</a>
              </li>
              <li>
                <a href="#team">Our Team</a>
              </li>
              <li>
                <a href="#careers">Careers</a>
              </li>
              <li>
                <a href="#fuel-cards">Fuel Cards</a>
              </li>
              <li>
                <a href="#locations">Locations</a>
              </li>
              <li>
                <a href="#contact">Contact</a>
              </li>
              <li>
                <a href="/login">Login</a>
              </li>
            </ul>
            <button className="y-mobile-menu-btn">☰</button>
          </nav>
        </div>
      </header>

      {/* Hero Section - Updated to extend full width */}
      <div className="y-hero-container">
        <div className="y-hero-image-container">
          <img
            src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/WhatsApp%20Image%202025-04-04%20at%202.06.41%20PM%20%281%29-tQCk2ZopOtU4qC2QacdIGBRk19v72K.jpeg"
            alt="Birdies Gas Station"
            className="y-hero-image"
          />
        </div>
        <div className="y-hero-text">
          <div className="y-container">
            <h1>Welcome to Birdies</h1>
            <p>
              Your one-stop destination for fuel, food, and service with a smile across 109 locations in Maryland,
              Virginia, DC, and North Carolina.
            </p>
            <a href="#locations" className="y-btn">
              Find a Location
            </a>
          </div>
        </div>
      </div>

      {/* About Section */}
      <section id="about">
        <div className="y-container">
          <div className="y-section-title">
            <h2>Our Mission</h2>
          </div>
          <div className="y-two-column">
            <div>
              <p>
                At Birdies, we pride ourselves on providing high-quality fuel and excellent customer service across 109
                locations in Maryland, Virginia, DC, and North Carolina. Whether you're refueling with trusted brands
                like Sunoco, Shell, or Exxon, or grabbing a fresh meal on the go, our commitment to professionalism and
                convenience is always front and center.
              </p>
              <p>
                We're more than a gas station—we're your one-stop destination for fuel, food, and service with a smile.
              </p>
            </div>
            <div
              className="y-column-img"
              style={{
                backgroundImage:
                  "url('https://hebbkx1anhila5yf.public.blob.vercel-storage.com/WhatsApp%20Image%202025-04-04%20at%202.05.19%20PM-gYxTNQzZvn2QNH9gxMgsuFZUsxLm9n.jpeg')",
              }}
            ></div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="y-features">
        <div className="y-container">
          <div className="y-section-title">
            <h2>Quality Service</h2>
            <p>Professionalism and Quality Service</p>
          </div>
          <div className="y-feature-grid">
            <div className="y-feature-card">
              <div
                className="y-feature-img"
                style={{
                  backgroundImage:
                    "url('https://hebbkx1anhila5yf.public.blob.vercel-storage.com/WhatsApp%20Image%202025-04-04%20at%202.06.41%20PM-GscyT1WIxQHMuXUmOSBZyvhmJixgPD.jpeg')",
                }}
              ></div>
              <div className="y-feature-content">
                <h3>Quality Fuel</h3>
                <p>
                  We partner with trusted brands like Sunoco, Shell, and Exxon to provide you with high-quality fuel for
                  your vehicle, ensuring optimal performance and efficiency.
                </p>
              </div>
            </div>
            <div className="y-feature-card">
              <div
                className="y-feature-img"
                style={{
                  backgroundImage:
                    "url('https://hebbkx1anhila5yf.public.blob.vercel-storage.com/WhatsApp%20Image%202025-04-04%20at%202.05.21%20PM%20%288%29-p4qpXB5wYgY6fVFzqtUPjrp6E0t65u.jpeg')",
                }}
              ></div>
              <div className="y-feature-content">
                <h3>Convenience Store</h3>
                <p>
                  Our convenience stores offer a wide selection of snacks, beverages, and essentials for travelers and
                  locals alike, making every stop at Birdies worthwhile.
                </p>
              </div>
            </div>
            <div className="y-feature-card">
              <div
                className="y-feature-img"
                style={{
                  backgroundImage:
                    "url('https://hebbkx1anhila5yf.public.blob.vercel-storage.com/WhatsApp%20Image%202025-04-04%20at%202.05.21%20PM%20%287%29-yt1Cf80FeNYeIFNH4B5wO9MgQsjGO0.jpeg')",
                }}
              ></div>
              <div className="y-feature-content">
                <h3>Clean Facilities</h3>
                <p>
                  At Birdies, we believe that every stop at our stations should be a seamless experience. With clean,
                  well-maintained locations and a team dedicated to excellent service, we go beyond just filling your
                  tank.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Food Section */}
      <section id="food">
        <div className="y-container">
          <div className="y-section-title">
            <h2>Delicious Food</h2>
            <p>
              Our food offerings are crafted for busy travelers and local commuters alike—serving fresh, hot meals to
              keep you going.
            </p>
          </div>
          <div className="y-two-column">
            <div
              className="y-column-img"
              style={{
                backgroundImage:
                  "url('https://hebbkx1anhila5yf.public.blob.vercel-storage.com/WhatsApp%20Image%202025-04-04%20at%202.05.21%20PM%20%286%29-TNmLi2Jcc6sjvDF6jsRzYOeZNuVqxI.jpeg')",
              }}
            ></div>
            <div>
              <h3>Order Food Online</h3>
              <p>
                Enjoy our delicious offerings from the comfort of your home or on the go. Our menu features a variety of
                options to satisfy your cravings, whether you're looking for a quick snack or a hearty meal.
              </p>
              <p>
                Many of our locations feature Subway restaurants, offering fresh sandwiches made to order, just the way
                you like them.
              </p>
              <a href="#" className="y-btn">
                Order Now
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section id="team" className="y-team">
        <div className="y-container">
          <div className="y-section-title">
            <h2>Our Team</h2>
            <p>The heart of Birdies is our dedicated team members who provide exceptional service every day.</p>
          </div>

          <div className="y-team-values">
            <div className="y-value-card">
              <div className="y-value-icon">★</div>
              <h3>Excellence</h3>
              <p>
                We strive for excellence in everything we do, from customer service to store cleanliness and product
                quality.
              </p>
            </div>
            <div className="y-value-card">
              <div className="y-value-icon">♥️</div>
              <h3>Community</h3>
              <p>
                Our team members are part of the local communities we serve, creating a welcoming environment for all
                customers.
              </p>
            </div>
            <div className="y-value-card">
              <div className="y-value-icon">↗️</div>
              <h3>Growth</h3>
              <p>
                We invest in our team members' development, providing opportunities for advancement and skill building.
              </p>
            </div>
          </div>

          <div className="y-team-image">
            <img
              src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/WhatsApp%20Image%202025-04-04%20at%202.05.21%20PM%20%284%29-TS6e18uM22VNR6K5PzbQbBEjawRqyT.jpeg"
              alt="Birdies Team Members"
            />
          </div>

          <div className="y-team-cta">
            <h3>Join Our Winning Team</h3>
            <p>
              At Birdies, we value our team members and provide a supportive, positive work environment where everyone
              can thrive. We offer competitive pay, flexible schedules, and opportunities for advancement.
            </p>
            <a href="#careers" className="y-btn">
              Explore Careers
            </a>
          </div>
        </div>
      </section>

      {/* Careers CTA */}
      <section id="careers" className="y-cta">
        <div className="y-container">
          <div className="y-section-title">
            <h2>Join the Birdies Team</h2>
            <p>
              Looking for a rewarding career? Birdies is always seeking motivated individuals to join our team across
              our 109 locations. Be a part of a company that values professionalism, customer service, and community
              involvement.
            </p>
          </div>
          <a href="#" className="y-btn y-btn-outline">
            Join Our Team
          </a>
        </div>
      </section>

      {/* Fuel Cards Section */}
      <section id="fuel-cards">
        <div className="y-container">
          <div className="y-section-title">
            <h2>Birdies Fuel Cards</h2>
          </div>
          <div className="y-two-column">
            <div>
              <h3>Manage Your Fuel Expenses</h3>
              <p>
                Manage your fleet or personal fuel expenses with ease using Birdies Fuel Cards. Accepted at all Birdies
                locations, our fuel cards provide convenience, control, and savings—whether you're fueling up with
                Sunoco, Shell, or Exxon.
              </p>
              <p>
                Our Shell V-Power Nitro+ premium fuel is available at many locations, giving your vehicle the
                performance it deserves while you enjoy the benefits of our fuel card program.
              </p>
              <a href="#" className="y-btn y-btn-accent">
                Learn More
              </a>
            </div>
            <div
              className="y-column-img"
              style={{
                backgroundImage:
                  "url('https://hebbkx1anhila5yf.public.blob.vercel-storage.com/WhatsApp%20Image%202025-04-04%20at%202.06.41%20PM-r7l7n8VVSVPAunlAuI7toSki4nfxsx.jpeg')",
              }}
            ></div>
          </div>
        </div>
      </section>

      {/* Locations Section */}
      <section id="locations" className="y-locations">
        <div className="y-container">
          <div className="y-section-title">
            <h2>Find a Birdies Near You</h2>
            <p>With 109 locations across Maryland, Virginia, DC, and North Carolina, we're always nearby.</p>
          </div>
          <div className="y-two-column">
            <div
              className="y-column-img"
              style={{
                backgroundImage:
                  "url('https://hebbkx1anhila5yf.public.blob.vercel-storage.com/WhatsApp%20Image%202025-04-04%20at%202.05.21%20PM%20%285%29-nQoJ6MJF2wOrRqbQsUNJgmZJHmFV5i.jpeg')",
              }}
            ></div>
            <div>
              <h3>Convenient Locations</h3>
              <p>
                Our 109 locations are strategically placed to serve you better. Whether you're on your daily commute or
                taking a road trip, you'll find a Birdies station ready to meet your needs.
              </p>
              <p>Each location offers quality fuel, convenience items, and our signature friendly service.</p>
              <a href="#" className="y-btn">
                Search Locations
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact">
        <div className="y-container">
          <div className="y-section-title">
            <h2>Get in Touch</h2>
            <p>We'd love to hear from you. Reach out with any questions or comments.</p>
          </div>
          <form className="y-contact-form"   onSubmit={handleSubmit} >
            <div className="y-form-group">
              <label htmlFor="name">Name</label>
              <input type="text" id="name" name="name" required />
            </div>
            <div className="y-form-group">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" name="email" required />
            </div>
            <div className="y-form-group">
              <label htmlFor="message">Message</label>
              <textarea id="message" name="message" required></textarea>
            </div>
            {status && <p>{status}</p>}
            <button type="submit" className="y-btn">
              Send Message
            </button>
          </form>
        </div>
      </section>

      {/* Footer */}
      <footer>
        <div className="y-container">
          <div className="y-footer-content">
            <div className="y-footer-column">
              <h3>Birdies</h3>
              <p>Your one-stop destination for fuel, food, and service with a smile across 109 locations.</p>
              <img
                src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Birdies%20Logo%20Plain%20%281%29%20%281%29.jpg-HOSyoEEoJ18kWlpTqlUZpdMIUD5Hzx.jpeg"
                alt="Birdies Logo"
                style={{ maxWidth: "150px", marginTop: "15px" }}
              />
            </div>
            <div className="y-footer-column">
              <h3>Quick Links</h3>
              <ul>
                <li>
                  <a href="#about">About Us</a>
                </li>
                <li>
                  <a href="#services">Services</a>
                </li>
                <li>
                  <a href="#food">Food</a>
                </li>
                <li>
                  <a href="#team">Our Team</a>
                </li>
                <li>
                  <a href="#careers">Careers</a>
                </li>
                <li>
                  <a href="#locations">Locations</a>
                </li>
              </ul>
            </div>
            <div className="y-footer-column">
              <h3>Services</h3>
              <ul>
                <li>
                  <a href="#">Shell Fuel</a>
                </li>
                <li>
                  <a href="#">Sunoco Fuel</a>
                </li>
                <li>
                  <a href="#">Exxon Fuel</a>
                </li>
                <li>
                  <a href="#">Subway</a>
                </li>
                <li>
                  <a href="#">Convenience Store</a>
                </li>
                <li>
                  <a href="#">Fuel Cards</a>
                </li>
              </ul>
            </div>
            <div className="y-footer-column">
              <h3>Contact</h3>
              <ul>
                <li>Email: support@birdiesstore.com</li>
                <li>Phone: 301-982-5400</li>
                <li>7303 Hanover pkwy greenbelt md 20770 STE A</li>
              </ul>
            </div>
          </div>
          <div className="y-copyright">
            <p>&copy; 2025 Birdies. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </>
  )
}

export default Homepage
